'use client';

import { useEffect } from 'react';
import { useQuery, useQueryClient } from 'react-query';

import { isServer } from '~/utils/ssr';
import type { StorageKeyType } from '~/utils/storage';
import { getStorageData, removeStorageData } from '~/utils/storage';

export function useSyncStorageEffect(
  effect: (payload: string) => void | Promise<void>,
  key: StorageKeyType,
) {
  const queryClient = useQueryClient();

  const { data: payload } = useQuery(
    key,
    () => (isServer() ? null : getStorageData(key)),
    {
      suspense: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: 'always',
      refetchOnMount: 'always',
    },
  );

  useEffect(() => {
    if (!payload) {
      return;
    }

    void effect(payload);
    queryClient.setQueryData(key, null);
    removeStorageData(key);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload]);
}
